import React from 'react';

import {ActionWithReasonButton} from './action-with-reason-button';

import type {ActionOptions, ActionWithReason} from './action-with-reason-button';

export type SaveOptions = ActionOptions;
export type SaveWithReason = ActionWithReason;

type Props = {
    onSave: SaveWithReason,
    busy?: boolean,
    disabled?: boolean,
};

export const SaveWithReasonButton = ({onSave, ...props}: Props) => (
    <ActionWithReasonButton {...props} action="Save" legacyLabel="Save Changes" onConfirm={onSave}/>
);
